import type { AdsLandingCardGrid } from "./types";

export function CardGrid({ cardGrid }: { cardGrid: AdsLandingCardGrid }) {
  if (cardGrid.cards.length === 0) {
    return null;
  }

  return (
    <div className="grid w-full grid-cols-1 gap-6 px-6 pt-10 md:grid-cols-3 lg:px-0">
      {cardGrid.cards.map((card) => (
        <article
          key={card.title}
          className="flex min-h-[226px] flex-col items-start rounded-[6px] border-[0.5px] border-[rgba(0,0,0,0.12)] bg-[rgba(0,0,0,0.01)] p-8"
        >
          <div className="flex w-full flex-col items-start gap-5">
            {card.icon ?
              <img
                src={card.icon.src}
                alt=""
                width={card.icon.width ?? 24}
                height={card.icon.height ?? 24}
                className="size-6 object-contain"
              />
            : null}
            <h3 className="text-primary text-[22px] leading-[1.26] font-medium text-balance">
              {card.title}
            </h3>
            {card.body ?
              <p className="text-secondary text-[17px] leading-7 text-balance">{card.body}</p>
            : null}
          </div>
        </article>
      ))}
    </div>
  );
}
